import { useState } from 'react';
import {
	BulkDeleteButton,
	Datagrid,
	DateField,
	FunctionField,
	List,
	TextField,
	TopToolbar,
	CreateButton,
	useDataProvider,
	useNotify,
	useRefresh

} from 'react-admin';
import { Switch } from '@mui/material';

const ListActions = () => (
	<TopToolbar>
		<CreateButton />
	</TopToolbar>
);

const SessionActiveToggle = ({ record }) => {
	const dataProvider = useDataProvider();
	const notify = useNotify();
	const refresh = useRefresh();
	const [ saving, setSaving ] = useState( false );
	const checked = record?.status === 'active';

	const handleChange = async ( event ) => {
		event.stopPropagation();
		const status = event.target.checked ? 'active' : 'inactive';
		setSaving( true );

		try {
			await dataProvider.update( 'sessions', {
				id: record.id,
				data: { ...record, status },
				previousData: record
			});
			notify( status === 'active' ? 'Session activated' : 'Session deactivated' );
			refresh();
		} catch ( error ) {
			notify( error.message || 'Session update failed', { type: 'error' } );
		} finally {
			setSaving( false );
		}
	};

	return (
		<Switch
			checked={checked}
			disabled={saving}
			onChange={handleChange}
			onClick={event => event.stopPropagation()}
			size="small"
		/>
	);
};

export const list = (props) => (
    <List {...props} actions={<ListActions />} exporter={false}>
        <Datagrid rowClick="edit" bulkActionButtons={<BulkDeleteButton mutationMode="pessimistic" />}>
            <TextField source="name" />
            <DateField source="start_date" />
            <FunctionField
                label="Active"
                render={record => <SessionActiveToggle record={record} />}
            />
        </Datagrid>
    </List>
);

export default list;
